import {IconButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, {useEffect, useState} from 'react';
import {firestore} from '../../Firebase';
import Heading from "../../Heading/JavaScript/Heading";
import Icons from '../../Icons/JavaScript/Icons';

function Customers() {
    const [disable, setDisable] = useState(false);
    const [moreLess, setMoreLess] = useState('More');
    const [customersData, setCustomersData] = useState([]);
    
    useEffect(
        () => {
            firestore.collection("Clients").onSnapshot(
                (snapShot) => {
                    setCustomersData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    imageURL: doc.data().imageURL,
                                    name: doc.data().name
                                }
                            )
                        )
                    )
                }
            )
        }, []
    )
    
    useEffect(
        () => {
            if (customersData.length === 0) {
                let customersSection = document.getElementsByClassName("customers")[0];
                
                customersSection.style.display = "none";
            }
            else {
                let customersSection = document.getElementsByClassName("customers")[0];
                
                customersSection.style.display = "grid";
            }
        }, [customersData.length]
    )
    
    const expand = () => {
        let iconsDiv = document.getElementsByClassName("customersIcons")[0];
        let customersExpandButton = document.getElementsByClassName("customers__expand__button")[0];
        let maxHeightValue;
        
        if (window.matchMedia("(max-width: 440px) and (max-height: 900px)").matches) {
            if (iconsDiv.offsetHeight < 165) {
                setDisable(true);
            }
            
            maxHeightValue = "47vw";
        }
        else {
            if (iconsDiv.offsetHeight < 490) {
                setDisable(true);
            }
            
            maxHeightValue = "36vw";
        }
        
        if (iconsDiv.style.maxHeight === maxHeightValue) {
            iconsDiv.style.maxHeight = "100%";
            customersExpandButton.style.transform = "rotate(180deg)";
            setMoreLess("Less");
        }
        else {
            iconsDiv.style.maxHeight = maxHeightValue;
            customersExpandButton.style.transform = "rotate(0deg)";
            setMoreLess("More");
        }
    }
    
    return (
        <section className="customers">
            <div className="customers__heading">
                <Heading text="Our Clients" />
            </div>
            <Icons type={"customersIcons"} data={customersData} />
            <IconButton className="customers__expand" onClick={expand} disabled={disable} data-aos="fade-down" data-aos-delay="4s00">
                <span className="customers__expand__text">Show {moreLess}</span>
                <ExpandMoreIcon className="customers__expand__button" />
            </IconButton>
        </section>
    )
}

export default Customers;
